import { useEffect, useState } from 'react';
import { PMPartsAndProcedure } from '../../types/pmTypes';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteServiceItemModalProps {
    item: PMPartsAndProcedure | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteServiceItemModal = ({
    item,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteServiceItemModalProps) => {
    const visible = Boolean(item?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    // Avoid click-through from the trash icon activating Delete as the modal opens.
    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, item?.id]);

    const itemName = item?.itemName?.trim() || item?.category?.trim() || 'this service item';
    const configCount = item?.pmConfigurationIds?.length || 0;

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete service item?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to permanently delete <strong>“{itemName}”</strong>. This cannot be undone.
            </p>
            {configCount > 0 && (
                <p>
                    This item is assigned to {configCount} PM configuration{configCount === 1 ? '' : 's'}.
                    Deleting it will remove it from all configurations.
                </p>
            )}
        </CustomModal>
    );
};
